import {getClientBrowserInfo} from './browserInformation';

export const scrollToInput = (inputElement: Element): void => {
    const info = getClientBrowserInfo();

    const isAndroidTouchDevice = /Android/.test(info.device) || /Android/.test(info.browser);

    if (isAndroidTouchDevice) {
        const inputHeight = inputElement.getBoundingClientRect().height;
        const scrollPosition = inputElement.getBoundingClientRect().top + window.scrollY - inputHeight;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
        });
    }
};
